import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { CarregamentoService } from './core/service/carregamento/carregamento.service';
import { LanguageService } from './language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [SharedModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  carregamentoService = inject(CarregamentoService);
  private languageService = inject(LanguageService);

  carregando = false;

  ngOnInit(): void {
    this.languageService.initialize();

    this.carregamentoService.carregando$.subscribe((valor) => {
      Promise.resolve().then(() => {
        this.carregando = valor;
      });
    });
  }
}
